import { TypeCode } from '../mbti/types';
import ABCT from './types/ABCT.jpg';
import ABCW from './types/ABCW.jpg';
import ABFT from './types/ABFT.jpg';
import ABFW from './types/ABFW.jpg';
import ASCT from './types/ASCT.jpg';
import ASCW from './types/ASCW.jpg';
import ASFT from './types/ASFT.jpg';
import ASFW from './types/ASFW.jpg';
import DBCT from './types/DBCT.jpg';
import DBCW from './types/DBCW.jpg';
import DBFT from './types/DBFT.jpg';
import DBFW from './types/DBFW.jpg';
import DSCT from './types/DSCT.jpg';
import DSCW from './types/DSCW.jpg';
import DSFT from './types/DSFT.jpg';
import DSFW from './types/DSFW.jpg';

export const TYPE_IMAGES: Record<TypeCode, string> = {
  ABCT, ABCW, ABFT, ABFW,
  ASCT, ASCW, ASFT, ASFW,
  DBCT, DBCW, DBFT, DBFW,
  DSCT, DSCW, DSFT, DSFW,
};
